"use client";
import { j as r } from "../../jsx-runtime-B6kdoens.js";
import { c as f, a as o } from "../../index-CROKJrb5.js";
import { c as p, f as x } from "../../create-component-CBAeEoQ6.js";
import { IconRenderer as c } from "../Icon/index.js";
import { Typography as d } from "../Typography/index.js";
import { PlaceholderIcon as h } from "../Icon/icons/PlaceholderIcon/index.js";
import { useBrand as j } from "../../brand/context/index.js";
const n = ({ className: s, ...e }) => /* @__PURE__ */ r.jsx(h, { className: o("cur-invisible", s), ...e }), g = f({
  base: "cur-flex cur-items-center cur-gap-2 cur-p-2",
  variants: {
    brand: {
      curology: "cur-bg-surface-secondary cur-text-inverse",
      agency: "cur-bg-surface-secondary cur-text-inverse"
    }
  }
}), k = p(
  "Banner",
  x(
    ({
      children: s,
      className: e,
      iconStart: t = n,
      iconPromo: a,
      iconEnd: i = n,
      ...m
    }, u) => {
      const l = j();
      return /* @__PURE__ */ r.jsxs(
        "header",
        {
          ref: u,
          className: g({
            brand: l,
            className: e
          }),
          ...m,
          children: [
            /* @__PURE__ */ r.jsx(
              c,
              {
                icon: t,
                size: "sm",
                className: "cur-w-4 cur-shrink-0"
              }
            ),
            /* @__PURE__ */ r.jsxs("div", { className: "cur-flex cur-w-full cur-items-center cur-justify-center", children: [
              /* @__PURE__ */ r.jsx(
                c,
                {
                  icon: a,
                  size: "sm",
                  className: "cur-mr-2 cur-w-4 cur-shrink-0"
                }
              ),
              /* @__PURE__ */ r.jsx(
                d,
                {
                  size: "meta",
                  weight: "bold",
                  className: o({ "cur-mr-6": !!a }),
                  children: s
                }
              )
            ] }),
            /* @__PURE__ */ r.jsx(
              c,
              {
                icon: i,
                size: "sm",
                className: "cur-w-4 cur-shrink-0"
              }
            )
          ]
        }
      );
    }
  )
);
export {
  k as Banner
};
//# sourceMappingURL=index.js.map
